import React from 'react';
export function ContactSection() {
  return <section className="w-full max-w-4xl mx-auto py-24 px-6 text-center border-t border-borderline mt-12" data-id="element-30">
      <h3 className="text-2xl md:text-3xl mb-6 text-offwhite tracking-wide" data-id="element-31">
        Get in Touch
      </h3>
      <p className="text-muted text-lg font-light max-w-xl mx-auto mb-8" data-id="element-32">
        For technology partnerships, co-production opportunities, or further
        information regarding the production.
      </p>
      <a href="mailto:dop2026live@gmail.com" className="inline-block text-offwhite border-b border-muted/30 pb-1 hover:border-offwhite transition-colors duration-500 tracking-wider" data-id="element-33">
        dop2026live@gmail.com
      </a>
    </section>;
}